import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

//material
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

//components
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';

//constants
import { RoutesConstants } from 'src/app/shared/constants';

@Component({
  selector: 'app-navigation-dialog',
  imports: [
    MatIconModule,
    MatDialogClose,
    MatButtonModule,
    FooterComponent
  ],
  templateUrl: './navigation-dialog.component.html',
  styleUrl: './navigation-dialog.component.scss'
})
export class NavigationDialogComponent {
  readonly data = inject<{ uuid: string }>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<NavigationDialogComponent>);

  public readonly menu: Array<{ title: string, url: string }> = [
    {
      title: 'Initiierung',
      url: RoutesConstants.WELCOME(this.data.uuid)
    },
    {
      title: 'Hilfe/Support',
      url: '/'
    },
  ];

  constructor(
    private router: Router
  ) { }

  goTo(item: { title: string, url: string }) {
    this.router.navigate([item.url]);
    this.dialogRef.close();
  }
}
